import { useAccountFlipperFeatureFlags } from '@libs/data-access/queries'
import { IconButton, PencilWriteIcon, Tooltip } from '@libs/ui/ds'
import { usePlanningTranslation } from '@libs/utils/translations'
import { useTrackScheduleFeaturesInteraction } from '@spa/core/externals/segment'
import { noteModalDef } from '@spa/scenes/Plannings/Modals/NoteModal'
import React from 'react'

import { noteModalLegacyDef } from '../../../../../Modals'
import { usePlanningPolicies } from '../../../../../redux/selectors'

const CreateNoteIcon = ({
  weeklyscheduleId,
  className,
  dayDate
}: {
  weeklyscheduleId: number
  className: string
  dayDate: string
}) => {
  const accountFF = useAccountFlipperFeatureFlags()
  const { open: openNoteLegacy } = noteModalLegacyDef.useDispatchModal()
  const { open } = noteModalDef.useDispatchModal()
  const { t } = usePlanningTranslation()
  const scheduleTracker = useTrackScheduleFeaturesInteraction()
  const { canEditNotes } = usePlanningPolicies()

  const handleClick = () => {
    scheduleTracker.dayNoteMenuOpened()
    if (accountFF?.scheduling_burning_redux) {
      open({
        weeklyscheduleId,
        date: dayDate
      })
    } else {
      openNoteLegacy({
        weeklyscheduleId,
        date: dayDate
      })
    }
  }

  if (!canEditNotes) {
    return null
  }

  return (
    <div className={className}>
      <Tooltip label={t('weekly.header.addNote')}>
        <IconButton
          size='xs'
          variant='secondary'
          intent='neutral-dark'
          icon={<PencilWriteIcon />}
          onClick={handleClick}
        />
      </Tooltip>
    </div>
  )
}

export default CreateNoteIcon
